import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Remove trailing slash if present (except for root path)
        if (pathname !== "/" && pathname.endsWith("/")) {
            navigate(pathname.slice(0, -1), { replace: true });
        }
        window.scrollTo(0, 0);
    }, [pathname, navigate]);

    return null;
}
